import { createDomain } from 'effector';

import { type DropdownName } from 'types/zod/dropdown-name';

const domain = createDomain('dropdowns');

const $$dropdowns = {
    $opened: domain.store<DropdownName[]>([]),

    open: domain.event<DropdownName>(),
    close: domain.event<DropdownName>(),
    toggle: domain.event<DropdownName>(),
};

export default $$dropdowns;
